import getStore from '../store/store';

export function getHighlightedEventId(): string | null {
    if (!getStore().meetingRequest || !getStore().meetingRequest.AssociatedCalendarItemId) {
        return null;
    }

    return getStore().meetingRequest.AssociatedCalendarItemId.Id;
}
